import { EnvironmentContext } from '../contexts/environment/EnvironmentContext'
import { useContext } from 'react'

export const useEnvironment = () => {
    return useContext(EnvironmentContext).config
}
